import Glide, { Breakpoints, Autoplay } from '@glidejs/glide/dist/glide.modular.esm'

document.addEventListener('turbo:load', () => {
  if(document.querySelector('.home-page.glide__slide')) {
    const glide = new Glide('.glide', {
      type: 'slider',
      bound: true,
      focusAt: 0, // Slide to focus on
      startAt: 0, // Starting slide index
      perView: 1, // Number of slides to show
      autoplay: 5000,
      hoverpause: false,
      breakpoints: {
        768: {
          perView: 1
        },
        1200: {
          perView: 1
        },
      },
      rewind: true, // Rewind to the first slide upon reaching the end
    })

    glide.on('run', () => {
      Array.from(glideArrows).forEach((arrow, index) => {
        if (index === glide.index) {
          arrow.classList.add('selected')
        } else {
          arrow.classList.remove('selected')
        }
      })
    })

    const glideArrows = document.querySelectorAll('.glide__arrow')
    
    Array.from(glideArrows).forEach((arrow, index) => {
      arrow.addEventListener('click', (e) => {
        Array.from(glideArrows).forEach((a) => {
          a.classList.remove('selected')
          
        })
        e.currentTarget.classList.add('selected')
        glide.go(`=${index}`) // Go to the next slide
      })
    })
    glide.mount({ Breakpoints, Autoplay }) // Mount the carousel
  }

  if(document.querySelector('.packages-outer-wrapper .glide__slide')) {
    const glide = new Glide('.glide', {
      type: 'slider',
      bound: true,
      focusAt: 0, // Slide to focus on
      startAt: 0, // Starting slide index
      perView: 1, // Number of slides to show
      autoplay: 5000,
      hoverpause: false,
      breakpoints: {
        768: {
          perView: 1
        },
        1200: {
          perView: 1
        },
      },
      rewind: true, // Rewind to the first slide upon reaching the end
    })

    glide.on('run', () => {
      // Check if the slider is at the first slide
      const isFirstSlide = glide.index === 0
      const isLastSlide = glide.index === document.querySelectorAll('.glide__slide').length - glide._o.perView
      const nextButton = document.querySelector('.glide__arrow--right')
      const prevButton = document.querySelector('.glide__arrow--left')
      const calendarWrapper = document.querySelector('.home-calendar-wrapper')
      if (prevButton) {
        if (isFirstSlide) {
          if(calendarWrapper) {
            calendarWrapper.classList.add('start')
            calendarWrapper.classList.remove('scrolled')
            calendarWrapper.classList.remove('end')
          }
          prevButton.classList.add('disabled')
          prevButton.disabled = true
        } else {
          if(calendarWrapper) {
            calendarWrapper.classList.remove('start')
            calendarWrapper.classList.add('scrolled')
            calendarWrapper.classList.remove('end')
          }
          prevButton.classList.remove('disabled')
          prevButton.disabled = false
        }
      }

      if (nextButton) {
        if (isLastSlide) {
          if(calendarWrapper) {
            calendarWrapper.classList.add('end')
          }
          nextButton.classList.add('disabled')
          nextButton.disabled = true
        } else {
          nextButton.classList.remove('disabled')
          nextButton.disabled = false
        }
      }
    })

    glide.mount({ Breakpoints, Autoplay }) // Mount the carousel

    document.querySelector('.glide__arrow--left').addEventListener('click', () => {
      glide.go('<') // Go to the previous slide
    })

    document.querySelector('.glide__arrow--right').addEventListener('click', () => {
      glide.go('>') // Go to the next slide
    })
  }
})